export default __webpack_public_path__ + "static/media/customer-support.fec8469f.svg";